export const patterns = {
  decimal: /\d+(\.\d+)?/g,
  blood_pressure: /^\d{1,3}\/\d{1,3}$/
};
